import React, { useEffect, useState } from 'react';
import { API_URL } from '../config/api';
import { useParams, useNavigate } from 'react-router-dom';
import { Loader2 } from 'lucide-react';

const QuoteAutoAccept = () => {
  const { quoteId } = useParams();
  const navigate = useNavigate();
  const [error, setError] = useState('');

  useEffect(() => {
    acceptQuote();
  }, [quoteId]);

  const acceptQuote = async () => {
    try {
      const response = await fetch(`${API_URL}/api/quotes/${quoteId}/accept-with-notifications`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' }
      });
      
      if (response.ok) {
        // Redirect to thank you page
        navigate(`/quote/${quoteId}/accepted`, { replace: true });
      } else {
        const data = await response.json();
        if (data.message === 'Quote already accepted') {
          // Already accepted, still go to thank you page
          navigate(`/quote/${quoteId}/accepted`, { replace: true });
        } else {
          setError('Unable to accept quote. Please try again or contact us.');
        }
      }
    } catch (err) {
      console.error('Error accepting quote:', err);
      setError('Connection error. Please try again.');
    }
  };

  if (error) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center px-4">
        <div className="max-w-md w-full bg-white rounded-2xl shadow-lg p-8 text-center">
          <p className="text-red-600 mb-4">{error}</p>
          <button
            onClick={() => navigate(`/quote/${quoteId}`)}
            className="text-[#1a1f4e] hover:underline"
          >
            View quote manually
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center">
      <div className="text-center">
        <Loader2 className="w-8 h-8 animate-spin text-[#1a1f4e] mx-auto mb-4" />
        <p className="text-gray-600">Accepting your quote...</p>
      </div>
    </div>
  );
};

export default QuoteAutoAccept;
